import React, { useState } from "react";
import "./ContactComp.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";

const ContactComp = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();


  // under developement this features
  // const submitQuery = async (data) => {
  //   try {
  //     const res = await fetch("https://manage.sampurnaskills.co.in/contact", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(data),
  //     });
  //     const result = await res.json();
  //   } catch (error) {}
  // };

  return (
    <>
      <section className="contact animate-slideup">
        <div className="container">
          <div className="contact-left">
            <h1>Contact Us</h1>
            <p>
              Want to work with us or need more details about{" "}
              <strong>SAMPURNA</strong>.
            </p>
            <form id="contact-form" onSubmit={handleSubmit()}>
              <div className="con-name">
                <div className="field name">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Your Name"
                    {...register("name", { required: "Field is required" })}
                  />
                </div>
                <div className="field number">
                  <input
                    type="number"
                    name="number"
                    id="number"
                    placeholder="Your Number"
                    {...register("number", { required: "Field is required" })}
                  />
                </div>
              </div>
              <div className="con-email">
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Your Email"
                  {...register("email", { required: "Field is required" })}
                />
              </div>
              <div className="con-textarea">
                <textarea
                  name="message"
                  id="massage"
                  cols="30"
                  rows="8"
                  placeholder="Describe your message"
                  {...register("query", { required: "Field is required" })}
                ></textarea>
              </div>
              <div className="button">
                <button type="submit" name="mailsend">
                  Send Massage
                </button>
              </div>
            </form>
          </div>

          <div className="contact-right">
            <div className="right-container">
              <div className="address">
                <i className="fa-solid fa-map-location"></i>{" "}
                <Link
                  to={"https://maps.app.goo.gl/WhEjaXoj8dB6avT38"}
                  target="_blank"
                >
                  <p>
                    3rd Floor (North), DN-30, Sector V, Salt Lake,
                    Kolkata-700091.
                  </p>
                </Link>
              </div>
              <div className="address">
                <i className="fa-solid fa-phone"></i>
                <div className="phone_no_group">
                  <Link to={"tel:+03335081849"}>
                    <p>Grievance Redressal: +91 033 3508 1849</p>
                  </Link>
                  <Link to={"tel:+916292276444"}>
                    <p>Toll Free Number: +91 62922 76444 </p>
                  </Link>
                  <Link to={"https://wa.me/+918100971969"} target="_blank">
                    <p>Whatsapp Number: +91 81009 71969 </p>
                  </Link>
                </div>
              </div>
              <div className="address">
                <i className="fa-solid fa-envelope"></i>{" "}
                <Link
                  to="https:///mail.google.com/mail/?view=cm&fs=1&to=contactus@sampurna.co.in"
                  target="_blank"
                >
                  <p>Email: contactus@sampurna.co.in</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
};

export default ContactComp;
